<template>
  <section class="img_edit">
    <el-form ref="editDataRefImg" :model="editData" label-width="100px">
      <el-row style="text-align: left">
        <el-col :span="24">
          <el-form-item label="选择模板:">
            <img class="img_edit__img" v-for="(item, index) in typeList" :key="index" @click="changeType(item, index)"
              :src="item.url" :style="item.style">
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="editData.imgType === 1">
          <el-form-item label="填充方式:">
            <el-radio @change="changeFullType" v-model="editData.fullType" label="1">留白
            </el-radio>
            <!--<el-radio @change="changeFullType" v-model="editData.fullType" label="2">填充</el-radio>-->
            <el-radio @change="changeFullType" v-model="editData.fullType" label="3">自然填充</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="width: 100%;min-height: 90px;margin-bottom: 20px" v-for="(item, index) in editData.imgList"
        :key="index">
        <el-col :span="6">
          <el-upload class="avatar-uploader" :action="SYSTEM_UPLOAD_URL" accept="image/*" ref="uploadImg"
            :with-credentials="true" :on-success="saveFileUrl" :show-file-list="false"
            :before-upload="beforeAvatarUpload" name="files">
            <img v-if="item.url" @click="selectImgIndex = index" :ref="editData.ref + index" :src="item.url"
              class="avatar">
            <i v-else @click="selectImgIndex = index" class="el-icon-plus avatar-uploader-icon"></i>
            <div style="color:red;margin-top:10px">图片大小在5M 以内</div>
          </el-upload>
        </el-col>
        <el-col :span="18" style="min-height: 90px">
          <el-row v-if="editData.imgType !== -1">
            <el-col :span="6" style="line-height: 30px;">跳转路径：</el-col>
            <el-col :span="18">
              <el-radio-group v-model="item.hrefType" @change="changeRedirectType($event,item)">
                <el-radio v-for="item in redirectTypeList" :key="item.value" :label="item.value">{{ item.label
                }}</el-radio>
              </el-radio-group>
            </el-col>
            <el-col :span="18" class="mt16">
              <el-select v-model="item.href" placeholder="请选择" v-if="item.hrefType == 1">
                <el-option v-for="item in menuList" :key="item.id" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-if="item.hrefType == 2" v-model="item.doctorId" filterable remote reserve-keyword placeholder="请输入医生姓名"
                :remote-method="remoteMethod" @change="doctorChange($event, item)">
                <el-option v-for="item in doctorOptions" :key="item.doctorId" :label="item.doctorName"
                  :value="item.doctorId">
                </el-option>
              </el-select>
              <el-input v-if="item.hrefType == 3" v-model="item.href" maxLength="200" placeholder="请输入链接地址" />
            </el-col>
          </el-row>
          <el-row style="height: 30px" v-if="editData.imgType === -1">
            <div v-for="(hot, hotIndex) in item.hotList" :key="hotIndex">
              <el-col :span="6" style="line-height: 30px;">热区{{ hotIndex + 1 }}：</el-col>
              <el-col :span="18">
                <el-radio-group v-model="hot.hrefType" @change="hotChangeRedirectType($event,hot)">
                  <el-radio v-for="item in redirectTypeList" :key="item.value" :label="item.value">{{ item.label
                  }}</el-radio>
                </el-radio-group>
              </el-col>
              <el-col :span="18" class="mb20">
                <el-col :span="18" class="mt16">
                  <el-select v-model="hot.href" placeholder="请选择" v-if="hot.hrefType == 1">
                    <el-option v-for="item in menuList" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-if="hot.hrefType == 2" v-model="hot.doctorId" filterable remote reserve-keyword
                    placeholder="请输入医生姓名" :remote-method="remoteMethod" @change="hotDoctorChange($event,hot)">
                    <el-option v-for="item in doctorOptions" :key="item.doctorId" :label="item.doctorName"
                      :value="item.doctorId">
                    </el-option>
                  </el-select>
                  <el-input v-if="hot.hrefType == 3" v-model="hot.href" maxLength="200" placeholder="请输入链接地址" />
                </el-col>
              </el-col>
            </div>
            <div>
              <el-col :span="24" style="line-height: 30px;text-align: center;margin-top: 5px;">
                <el-button type="primary" size="mini" @click="addHot(item, index)">
                  {{ item.hotList && item.hotList.length == 0 ? '添加热区' : '编辑热区' }}
                </el-button>
              </el-col>
            </div>
          </el-row>
        </el-col>
      </el-row>
      <div class="addImg" v-if="editData.imgType === 0" style="border: 1px solid #0074D9;cursor: pointer;"
        @click="addImgList">
        <i class="el-icon-plus"></i>
        添加图片
      </div>
    </el-form>
    <hot :hot-data="hot" @close="closeHot"></hot>
  </section>
</template>

<script type="text/babel">
import Hot from '@/components/hot/hot'
import { uploadTemporaryFile } from "@/api/post"; // 科室请求
import { queryClientList, doctorInfo } from "@/api/doctor"
import { debounce, dictText, deepClone } from "@/utils/validateBase";
const EVENTS = {
  CHANGE: 'change',
  SCROLL_CHANGE: 'scroll-change'
}

export default {
  name: 'img-edit',
  components: {
    Hot
  },
  props: {
    editData: {},
    dynamicPageApply: {
      type: Number,
      default: 2,
    }
  },
  data() {
    return {
      SYSTEM_UPLOAD_URL: '/xl/upload/temp/file/upload',
      selectImgIndex: '',
      typeList: [
        {
          url: require('@/assets/images/carousel_bg1.jpg'),
          type: 1,
          checked: false,
          style: 'border-color:#409EFF'
        },
        {
          url: require('@/assets/images/carousel_bg.jpg'),
          type: 0,
          checked: false,
          style: ''
        },
        {
          url: require('@/assets/images/carousel_bghotZone.jpg'),
          type: -1,
          checked: false,
          style: ''
        },
      ],
      urlList: [],
      urlListApp: [],
      filter: {
        page: {
          pageIndex: 1,
          pageSize: 10,
          params: null,
          medicinePharmacyId: null,
          medicineUp: 1,  // 药品上架
          medicineSale: 1 // 药品可售
        }
      },
      loading: false,
      medicineList: [],
      hot: {
        visible: false,
        list: [
          {
            top: 0,
            left: 0,
            height: 200,
            width: 200,
            href: null,
            medNumber: null,
            hrefType: 1,
            doctorName: '',
            doctorId: '',
          }
        ],
        imgUrl: null
      },
      couponId: null,
      couponIdLian: null, // 选择一个连锁优惠券
      couponIdDan: null, // 选择一个单体优惠券
      couponIds: [],
      couponIdsLian: [], // 选择两个连锁优惠券
      couponIdsDan: [], // 选择两个单体优惠券
      params: {
        pageIndex: 1,
        pageSize: 10,
        params: null,
        medicinePharmacyId: 1
      },
      redirectTypeList: [
        { label: '菜单', value: 1 },
        { label: '医生主页', value: 2 },
        { label: '动态页面', value: 3 },
      ],
      menuList: [
        { id: 1, label: '门诊预约', value: '/pages/deptRegister/deptRegister' },
        { id: 2, label: '在线咨询', value: '/secondPages/doctorOnlineList/doctorOnlineList' },
        { id: 3, label: '理疗预约', value: '/physio/reservationHome/reservationHome' },
        { id: 4, label: '自助续方', value: '/secondPages/selfServiceIndex/selfServiceIndex' },
        { id: 5, label: '挂号记录', value: '/secondPages/registerList/registerList' },
        { id: 6, label: '处方订单', value: '/secondPages/orderList/orderList?status=all' },
        { id: 7, label: '理疗记录', value: '/physio/reservationRecordList/reservationRecordList' },
        { id: 8, label: '我的咨询', value: '/secondPages/onlineList/onlineList' },
        { id: 9, label: '充值余额', value: '/secondPages/recharge/recharge' },
        { id: 10, label: '优惠券列表', value: '/secondPages/couponList/couponList' },
      ],
      doctorOptions: [],
    }
  },
  watch: {
    dynamicPageApply(val) {
      this.urlList = this.dynamicPageApply == 2 ? this.urlListXCX : this.urlListApp
    }
  },
  mounted() {
    // this.init()
    this.couponIdsFill()
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 < 5 * 1024 * 1024;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5M!');
      }
      return isLt2M;
    },
    init() {
      this.urlListXCX = this.$lodash.clone(ACTIVITY_URL_LIST)
      this.urlListApp = this.$lodash.clone(ACTIVITY_URL_LIST_APP)
      this.urlListXCX.push({
        label: '选择推荐门店药品',
        value: '/three-pages/goodsDetails/goodsDetails'
      })
      this.urlListApp.push({
        label: '选择推荐门店药品',
        value: '/three-pages/goodsDetails/goodsDetails'
      }, {
        label: '积分商城',
        value: '/pages/integralmall/integralmall'
      }, {
        label: '签到有礼',
        value: '/other-pages/pages/signIn/signIn'
      })
      this.urlList = this.dynamicPageApply == 2 ? this.urlListXCX : this.urlListApp
    },
    addImgList() {
      const addData = {
        src: '',
        title: '',
        href: '',
        sort: '',
        url: ''
      }
      if (this.editData.imgType === -1) {
        addData['hotList'] = []
      }
      this.editData.imgList.push(addData)
    },
    saveFileUrl(response) {
      const vm = this
      const index = vm.selectImgIndex
      const row = vm.$lodash.cloneDeep(vm.editData.imgList[index])
      if (response.data) {
        let arr = []
        arr[0] = { uploadChannel: "postImg", fileId: response.data[0].fileId, groupName: "group1", isNeedThumbnail: "2" }
        uploadTemporaryFile(arr).then(uploadRes => {
          if (uploadRes.errorCode == '0000') {
            row.url = uploadRes.data[0].fullPathUrl
            row.src = uploadRes.data[0].shortPathUrl
            vm.editData.imgList.splice(index, 1, row)
            vm.$nextTick(() => {
              vm.$refs[vm.editData.ref + index][0].onload = () => {
                const naturalWidth = vm.$refs[vm.editData.ref + index][0].naturalWidth
                const naturalHeight = vm.$refs[vm.editData.ref + index][0].naturalHeight
                row['originWidth'] = naturalWidth
                row['originHeight'] = naturalHeight
                vm.editData.imgList.splice(index, 1, row)
                if (vm.verifyImgSize(index, row, naturalWidth, naturalHeight)) {
                  vm.changeFullType(row, index)
                }
              }
            })
          } else {
            this.$message.error('上传失败')
          }
        }).catch(err => {
          this.$message.error('上传失败')
        })
      } else {
        vm.$message.error(response.errorMessage)
      }
    },
    changeType(row, index) {
      const vm = this
      if (row && row.url) {
        vm.typeList.map((ele, indexs) => {
          ele.checked = false
          ele.style = null
          if (index === indexs) {
            ele.checked = true
            ele.style = 'border-color:#409EFF'
          }
          return ele
        })
        if (row.type === -1 || row.type === 0) {
          if (row.type === -1) {
            vm.editData.imgList.map((ele) => {
              ele['hotList'] = []
              ele.href = null
              ele.hrefType = null
              ele.medicineNumber = null
              return ele
            })
          }
          vm.editData.fullType = '3'
          vm.changeFullType()
        } else if (row.type === 1 && vm.editData.imgList.length > 1) {
          vm.editData.imgList = vm.$lodash.cloneDeep(vm.editData.imgList.slice(0, 1))
        }
        vm.editData.imgType = row.type
      } else {
        vm.typeList.map((ele) => {
          ele.checked = false
          ele.style = null
          if (ele.type === vm.editData.imgType) {
            ele.checked = true
            ele.style = 'border-color:#409EFF'
          }
          return ele
        })
      }
    },
    changeFullType(row, index = 0) {
      const vm = this
      const changeData = vm.editData
      let imgWidth = 268
      let imgHeight = 100
      vm.$nextTick(() => {
        const naturalWidth = vm.$refs[changeData.ref + index][0].naturalWidth
        const naturalHeight = vm.$refs[changeData.ref + index][0].naturalHeight
        const proportion = naturalWidth / naturalHeight
        if (changeData.fullType == '1') {
          if (proportion > 1) {
            imgHeight = imgWidth / proportion
          } else if (proportion == 1) {
            imgWidth = 100
          } else {
            imgHeight = imgWidth / proportion
            // imgWidth = imgHeight * proportion
          }
        } else if (changeData.fullType == '3') {
          if (proportion >= 1) {
            imgHeight = imgWidth / proportion
          } else {
            imgHeight = imgWidth / naturalWidth * naturalHeight
          }
        }
        changeData.height = imgHeight.toString()
        changeData.width = imgWidth.toString()
        vm.$refs[vm.editData.ref + index][0].onload = null
      })
    },
    verifyImgSize(index, row, width, height) {
      const vm = this
      const differentSizeIndex = vm.editData.imgList.findIndex((ele) => (ele.src && ele.originWidth && ele.originWidth !== width) || (ele.src && ele.originHeight && ele.originHeight !== height))
      if (differentSizeIndex >= 0 && vm.editData.imgList.length > 1) {
        row.url = null
        row.src = null
        vm.editData.imgList.splice(index, 1, row)
        vm.$message.error('请上传相同尺寸的图片')
        return false
      }
      return true
    },
    change() {
      // this.$emit(EVENTS.CHANGE, this.editData)
    },
    couponChange(chooseId) {
      const vm = this
      vm.editData.data = []
      if (vm.couponIdLian) {
        let oneCoupon = vm.editData.couponList.find((ele) => vm.couponIdLian == ele.couponId)
        if (oneCoupon) {
          vm.editData.data.push(oneCoupon)
        }
      }
      if (vm.couponIdDan) {
        let twoCoupon = vm.editData.couponList.find((ele) => vm.couponIdDan == ele.couponId)
        if (twoCoupon) {
          vm.editData.data.push(twoCoupon)
        }
      }
      if (vm.couponIdLian && vm.couponIdDan) {
        vm.editData.couponId = vm.couponIdLian + ',' + vm.couponIdDan
      } else if (vm.couponIdLian && !vm.couponIdDan) {
        vm.editData.couponId = vm.couponIdLian
      } else if (!vm.couponIdLian && vm.couponIdDan) {
        vm.editData.couponId = vm.couponIdDan
      }
      vm.editData.rowCount = 1
    },
    couponChangeTwo() {
      const vm = this
      vm.editData.data = []
      if (vm.couponIdsLian.length > 0) {
        let oneCoupon = vm.editData.couponList.find((ele) => vm.couponIdsLian[0] == ele.couponId)
        let twoCoupon = vm.editData.couponList.find((ele) => vm.couponIdsLian[1] == ele.couponId)
        if (oneCoupon) {
          vm.editData.data.push(oneCoupon)
        }
        if (twoCoupon) {
          vm.editData.data.push(twoCoupon)
        }
      }
      if (vm.couponIdsDan.length > 0) {
        let threeCoupon = vm.editData.couponList.find((ele) => vm.couponIdsDan[0] == ele.couponId)
        let fourCoupon = vm.editData.couponList.find((ele) => vm.couponIdsDan[1] == ele.couponId)
        if (threeCoupon) {
          vm.editData.data.push(threeCoupon)
        }
        if (fourCoupon) {
          vm.editData.data.push(fourCoupon)
        }
      }
      vm.editData.couponId = ''
      if (vm.couponIdsLian[0]) {
        if (vm.editData.data.length > 1) {
          vm.editData.couponId += (vm.couponIdsLian[0] + ',')
        } else {
          vm.editData.couponId += vm.couponIdsLian[0]
        }
      }
      if (vm.couponIdsLian[1]) {
        if (vm.editData.data.length > 1) {
          vm.editData.couponId += (vm.couponIdsLian[1] + ',')
        } else {
          vm.editData.couponId += vm.couponIdsLian[1]
        }
      }
      if (vm.couponIdsDan[0]) {
        if (vm.editData.data.length > 1) {
          vm.editData.couponId += (vm.couponIdsDan[0] + ',')
        } else {
          vm.editData.couponId += vm.couponIdsDan[0]
        }
      }
      if (vm.couponIdsDan[1]) {
        if (vm.editData.data.length > 1) {
          vm.editData.couponId += (vm.couponIdsDan[1] + ',')
        } else {
          vm.editData.couponId += vm.couponIdsDan[1]
        }
      }
      vm.editData.rowCount = 2
    },

    couponIdsFill() {
      const vm = this
      vm.couponId = null
      vm.couponIds = []
      vm.couponIdLian = null
      vm.couponIdDan = null
      vm.couponIdsLian = []
      vm.couponIdsDan = []
      if (vm.editData.couponIds) {
        vm.editData.couponIds.forEach((ele, index) => {
          let coupon = vm.editData.couponList.find(o => o.couponId == ele)
          if (coupon) {
            if (coupon.couponPharmacyLevel == 1) {
              vm.couponIdDan = coupon.couponId
            } else {
              vm.couponIdLian = coupon.couponId

            }
          }
        })
      }
    },
    /*
     * 跳转路径变化
     * */
    selectChange(query, item, index) {
      if (query !== '/three-pages/goodsDetails/goodsDetails' && item.medicineNumber) {
        item.medicineNumber = null
        this.editData.imgList.splice(index, 1, item)
      }
    },
    selectHotChange(query, item, index, hotIndex) {
      if (query !== '/three-pages/goodsDetails/goodsDetails' && item.hotList[hotIndex].medNumber) {
        item.hotList[hotIndex].medNumber = null
        this.editData.imgList.splice(index, 1, item)
      }
    },
    addHot(item, index) {
      const vm = this
      if (item.url) {
        vm.hot.visible = true
        vm.hot.imgUrl = item.url
        vm.hot.index = index
        if (item.hotList && item.hotList.length > 0) {
          vm.hot.list = item.hotList
        }
      } else {
        vm.$message.error('请先上传图片')
      }
    },
    closeHot(list) {
      const vm = this;
      vm.hot.visible = false;
      const item = vm.editData.imgList[vm.hot.index];
      item.hotList = list;
      vm.editData.imgList.splice(vm.hot.index, 1, item)
    },
    changeRedirectType(val,item) {
      this.doctorOptions = []
      item.href = null
      if (val == 2) {
        item.doctorName = null
        item.doctorId = null
      }
    },
    remoteMethod: debounce(async function (query) {
      let { code, rows } = await queryClientList({ searchValue: query, pageSize: 100, pageNum: 1 })
      if (code === 200) {
        this.doctorOptions = rows
      }
    }, 300, true),
    doctorChange(val,item) {
      let info = this.doctorOptions.find(item => item.doctorId == val)
      item.doctorName = info.doctorName
      item.doctorId = val
      this.$forceUpdate()
    },
    hotChangeRedirectType(val,hot){
      this.doctorOptions = []
      hot.href = null
      if (val == 2) {
        hot.doctorId = ''
        this.doctorName = null
      }
    },
    hotDoctorChange(val,hot){
      let info = this.doctorOptions.find(item => item.doctorId == val)
      hot.doctorName = info.doctorName
      hot.doctorId = val
      this.$forceUpdate()
    }
  },

}
</script>

<style lang="scss" scoped>
.img_edit {
  font-size: 14px;
}

.img_edit__img {
  height: 98px;
  width: 98px;
  border: 1px solid #c4c4c4;
  cursor: pointer;
  margin-right: 10px;
}

.addImg {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #409EFF;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  border: 1px dashed #409EFF;
  line-height: 90px;
  text-align: center;
}

.avatar {
  width: 88px;
  height: 88px;
  display: block;
}
</style>
